// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Overlay for the dialog */
.dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
  }
  
  /* Dialog content */
  .dialog-content {
    background-color: #fff;
    border-radius: 10px;
    width: 600px;
    max-width: 90%;
    padding: 20px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    position: relative;
    border: 1px solid #e0e0e0;
  }
  
  /* Header with royal blue background */
  .dialog-header {
    background-color: #3252a8; /* Royal blue color */
    border-radius: 5px 5px 0 0;
    padding: 10px;
    text-align: center;
  }
  
  .dialog-title {
    color: white;
    font-size: 22px;
    margin: 0;
    font-weight: bold;
  }
  
  /* Body for the dialog */
  .dialog-body {
    padding: 20px;
    max-height: 400px;
    overflow-y: auto;
  }
  
  /* Input field styling */
  .file-input {
    border: 1px solid #ddd;
    padding: 10px;
    width: 100%;
    border-radius: 5px;
    box-sizing: border-box;
    background-color: #f9f9f9;
    font-size: 14px;
    cursor: not-allowed;
  }
  
  /* Styling for download icon inside input field */
  .download-icon {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    text-decoration: none;
    color: #3252a8; /* Royal blue for the icon */
  }
  
  .download-icon:hover {
    color: #27408b; /* Navy blue for hover effect */
  }
  
  /* Close button */
  .btn-secondary {
    padding: 10px 20px;
    background-color: #3252a8;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    text-align: center;
    margin: 10px auto;
    display: block;
    font-size: 16px;
  }
  
  .btn-secondary:hover {
    background-color: #27408b; /* Navy blue for hover effect */
  }
  /* Style for the outer card */
.document-card {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 20px;
  background-color: #ffffff; /* White background */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Subtle shadow */
  margin-bottom: 20px;
}

/* Card title styling */
.card-title {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333;
}

/* Style for the document list */
.document-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

/* Individual document item styling */
.document-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
}

/* Document section styling */
.document-section {
  display: flex;
  align-items: center;
  gap: 10px;
}
.attachment-link{
  margin-top: 8px;
}
/* Attachment icon */
.attachment-icon {
  font-size: 1.5rem;
  color: #007bff; /* Primary color */
}

.attachment-icon:hover {
  color: #0056b3; /* Darker shade on hover */
  cursor: pointer;
}

/* Document details styling */
.document-details {
  display: flex;
  flex: 1 1;
  gap: 10px;
}

.file-input {
  flex: 1 1;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px;
  font-size: 0.9rem;
}

/* Remarks section styling */
.remarks-section {
  margin-top: 10px;
}

.remark-text {
  font-size: 0.9rem;
  font-weight: bold;
  color: black;
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/components/tracktrace/CustomDialogViewing.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;EACd;;EAEA,mBAAmB;EACnB;IACE,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,aAAa;IACb,wCAAwC;IACxC,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA,sCAAsC;EACtC;IACE,yBAAyB,EAAE,qBAAqB;IAChD,0BAA0B;IAC1B,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,SAAS;IACT,iBAAiB;EACnB;;EAEA,wBAAwB;EACxB;IACE,aAAa;IACb,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA,wBAAwB;EACxB;IACE,sBAAsB;IACtB,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,eAAe;IACf,mBAAmB;EACrB;;EAEA,iDAAiD;EACjD;IACE,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,qBAAqB;IACrB,cAAc,EAAE,4BAA4B;EAC9C;;EAEA;IACE,cAAc,EAAE,+BAA+B;EACjD;;EAEA,iBAAiB;EACjB;IACE,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,yBAAyB,EAAE,+BAA+B;EAC5D;EACA,6BAA6B;AAC/B;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,yBAAyB,EAAE,qBAAqB;EAChD,wCAAwC,EAAE,kBAAkB;EAC5D,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA,gCAAgC;AAChC;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,cAAc,EAAE,kBAAkB;AACpC;;AAEA;EACE,cAAc,EAAE,0BAA0B;EAC1C,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,SAAO;EACP,SAAS;AACX;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,0BAA0B;AAC5B","sourcesContent":["/* Overlay for the dialog */\n.dialog-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.6);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 999;\n  }\n  \n  /* Dialog content */\n  .dialog-content {\n    background-color: #fff;\n    border-radius: 10px;\n    width: 600px;\n    max-width: 90%;\n    padding: 20px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    position: relative;\n    border: 1px solid #e0e0e0;\n  }\n  \n  /* Header with royal blue background */\n  .dialog-header {\n    background-color: #3252a8; /* Royal blue color */\n    border-radius: 5px 5px 0 0;\n    padding: 10px;\n    text-align: center;\n  }\n  \n  .dialog-title {\n    color: white;\n    font-size: 22px;\n    margin: 0;\n    font-weight: bold;\n  }\n  \n  /* Body for the dialog */\n  .dialog-body {\n    padding: 20px;\n    max-height: 400px;\n    overflow-y: auto;\n  }\n  \n  /* Input field styling */\n  .file-input {\n    border: 1px solid #ddd;\n    padding: 10px;\n    width: 100%;\n    border-radius: 5px;\n    box-sizing: border-box;\n    background-color: #f9f9f9;\n    font-size: 14px;\n    cursor: not-allowed;\n  }\n  \n  /* Styling for download icon inside input field */\n  .download-icon {\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    text-decoration: none;\n    color: #3252a8; /* Royal blue for the icon */\n  }\n  \n  .download-icon:hover {\n    color: #27408b; /* Navy blue for hover effect */\n  }\n  \n  /* Close button */\n  .btn-secondary {\n    padding: 10px 20px;\n    background-color: #3252a8;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    text-align: center;\n    margin: 10px auto;\n    display: block;\n    font-size: 16px;\n  }\n  \n  .btn-secondary:hover {\n    background-color: #27408b; /* Navy blue for hover effect */\n  }\n  /* Style for the outer card */\n.document-card {\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  padding: 20px;\n  background-color: #ffffff; /* White background */\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Subtle shadow */\n  margin-bottom: 20px;\n}\n\n/* Card title styling */\n.card-title {\n  font-size: 1.2rem;\n  font-weight: bold;\n  margin-bottom: 15px;\n  color: #333;\n}\n\n/* Style for the document list */\n.document-list {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n\n/* Individual document item styling */\n.document-item {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 15px;\n}\n\n/* Document section styling */\n.document-section {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.attachment-link{\n  margin-top: 8px;\n}\n/* Attachment icon */\n.attachment-icon {\n  font-size: 1.5rem;\n  color: #007bff; /* Primary color */\n}\n\n.attachment-icon:hover {\n  color: #0056b3; /* Darker shade on hover */\n  cursor: pointer;\n}\n\n/* Document details styling */\n.document-details {\n  display: flex;\n  flex: 1;\n  gap: 10px;\n}\n\n.file-input {\n  flex: 1;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  padding: 8px;\n  font-size: 0.9rem;\n}\n\n/* Remarks section styling */\n.remarks-section {\n  margin-top: 10px;\n}\n\n.remark-text {\n  font-size: 0.9rem;\n  font-weight: bold;\n  color: black;\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
